<script setup lang="ts">
import type { ComboboxEmptyProps } from "reka-ui";
import { ComboboxEmpty } from "reka-ui";
import Text from "../Text.vue";

const props = defineProps<ComboboxEmptyProps>();
</script>

<template>
  <ComboboxEmpty
    v-bind="props"
    as-child
  >
    <Text class="py-6 text-center select-none">
      <slot />
    </Text>
  </ComboboxEmpty>
</template>
